import { createTheme } from "@material-ui/core/styles";

export default createTheme({
    overrides: {
        MuiAppBar: {
            colorPrimary: {
                backgroundColor: "#000",
            },
        },
        MuiButton: {
            containedPrimary: {
                "&:hover": {
                    backgroundColor: "#000",
                },
            },
        },
        MuiTooltip: {
            popperArrow: {
                marginBottom: -12,
            },
            arrow: {
                color: "#dcdcdc",
            },
            tooltip: {
                color: "#525252",
                backgroundColor: "#dcdcdc",
            },
        },
    },
    palette: {
        type: "light",
        common: {
            black: "#000",
            white: "#fff",
        },
        background: {
            paper: "#fff",
            default: "#eaeaea",
        },
        primary: {
            light: "#7986cb",
            main: "rgba(0, 0, 0, 87)",
            dark: "#303f9f",
            contrastText: "#fff",
        },
        secondary: {
            light: "#ff4081",
            main: "rgba(245, 124, 0, 1)",
            dark: "#c51162",
            contrastText: "#fff",
        },
        error: {
            light: "#e57373",
            main: "#f44336",
            dark: "#d32f2f",
            contrastText: "#fff",
        },
        text: {
            primary: "rgba(0,0,0,0.87)",
            secondary: "rgba(0, 0, 0, 0.6)",
            disabled: "rgba(0, 0, 0, 0.38)",
            hint: "rgba(0, 0, 0, 0.38)",
        },
    },
});
